module.exports = __webpack_public_path__ + "img/wancheng.378b59d0.png";